module.exports = __webpack_public_path__ + "static/media/check_mail.c89c2ce3.png";